import React, { FormEvent, FC } from 'react'
import './Form.less'
import classnames from 'classnames'
import { Box } from 'front-end/src/components'
import { BoxProps } from '@chakra-ui/react'

type FormProps = {
  children: any
  onSubmit?: (val: FormEvent<HTMLFormElement>) => void
} & Partial<React.HTMLAttributes<HTMLFormElement>>

type FormRowProps = {
  className?: string
} & BoxProps

/**
 * just very thin wrapper for regular form element. Prevents default action which is undesirable in an SPA
 */
const Form = ({ children, onSubmit, ...props }: FormProps) => {
  return (
    <form
      className="Form"
      onSubmit={(ev) => {
        onSubmit && onSubmit(ev)
        ev.preventDefault()
        return false
      }}
      {...props}
    >
      {children}
    </form>
  )
}
export default Form

export const FormRow: FC<FormRowProps> = ({
  children,
  className,
  ...props
}) => {
  const combinedClassName = classnames('FormRow', className)

  return (
    <Box className={combinedClassName} {...props}>
      {children}
    </Box>
  )
}
